/* eslint-disable no-console */
import { Locale } from '@wyz/types';
import { Locale as LocaleModule } from 'date-fns';

export const DEFAULT_LOCALE: Locale = 'en-GB';

export const getLocaleModule = (locale: Locale): Promise<LocaleModule> => {
  return new Promise((resolve, reject) => {
    return loadDateFnsLocaleData(locale)
      .then((localeModule) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        resolve(localeModule.default);
      })
      .catch(() => {
        // retry with language only
        const language = locale.split('-')[0];
        return loadDateFnsLocaleData(language).then((localeModule) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          resolve(localeModule.default);
        });
      })
      .catch((error: Error) => {
        console.error(
          `Failed to load locale data for date-fns for ${locale}`,
          error,
        );
        reject(error);
      });
  });
};

function loadDateFnsLocaleData(locale: string) {
  return import(
    /* @vite-ignore */
    `https://cdn.jsdelivr.net/npm/date-fns@4.1.0/locale/${locale}/+esm`
  );
}
type DisplayNameOps = {
  type: 'language' | 'region';
};
function getDisplayNames(
  locale: string,
  options: DisplayNameOps = { type: 'language' },
) {
  return new Intl.DisplayNames([locale], {
    type: options.type,
    fallback: 'code',
    languageDisplay: 'standard',
    style: 'narrow',
  });
}
export const getHumanReadableLabel = ({
  locale,
  userLocale,
  fallback,
  options,
}: {
  locale: Locale;
  userLocale: Locale;
  fallback: string;
  options?: DisplayNameOps;
}) => {
  let displayNames;
  // Create an Intl.DisplayNames instance with the display locale
  try {
    displayNames = getDisplayNames(userLocale, options);
  } catch (error) {
    try {
      // try the default
      displayNames = getDisplayNames(DEFAULT_LOCALE, options);
    } catch (error) {
      // return the fallback
      return fallback;
    }
  }
  // Get the human-readable label
  try {
    return displayNames.of(locale);
  } catch (error) {
    return fallback;
  }
};
